import React, { useState } from 'react';
import { LifeBuoy, X, Wind } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { VIDEOS } from '../data/videos';
import { VideoPlayer } from './VideoPlayer';

const SOS_VIDEO = VIDEOS.find((v) => v.id === 'respiration-profonde');

// Floating SOS button - opens a modal with the deep breathing video
export const SOSButton = () => {
  const { language } = useLanguage();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-[max(1rem,env(safe-area-inset-bottom))] right-4 sm:bottom-6 sm:right-6 z-40 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-rose-500 to-red-600 text-white shadow-2xl hover:scale-110 transition-transform duration-200 flex items-center justify-center group animate-pulse-slow"
        data-testid="sos-craving-btn"
        aria-label="SOS Craving"
      >
        <LifeBuoy className="w-7 h-7 group-hover:rotate-12 transition-transform" />
        <span className="absolute -top-2 -left-2 bg-white text-red-600 text-[10px] font-black px-2 py-0.5 rounded-full shadow">SOS</span>
      </button>

      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 animate-fade-in" data-testid="sos-modal">
          <div className="bg-white rounded-3xl max-w-2xl w-full p-5 sm:p-8 shadow-2xl relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center"
              data-testid="sos-close-btn"
            >
              <X className="w-5 h-5 text-gray-600" />
            </button>

            <div className="text-center mb-5">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-rose-100 flex items-center justify-center mb-3">
                <Wind className="w-7 h-7 text-rose-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-1">
                {language === 'fr' ? 'SOS Envie de fumer' : 'SOS Craving'}
              </h2>
              <p className="text-sm text-gray-600">
                {language === 'fr'
                  ? "La respiration profonde : l'envie passe en général en 3 à 5 minutes"
                  : 'Deep breathing: cravings usually pass in 3 to 5 minutes'}
              </p>
            </div>

            <div className="aspect-video rounded-2xl overflow-hidden bg-black">
              <VideoPlayer video={SOS_VIDEO} className="w-full h-full" autoPlay testId="sos-video-player" />
            </div>

            <button
              onClick={() => setOpen(false)}
              className="w-full mt-5 py-3 rounded-full border-2 border-gray-200 text-gray-700 font-semibold hover:bg-gray-50"
              data-testid="sos-dismiss-btn"
            >
              {language === 'fr' ? 'Fermer' : 'Close'}
            </button>
          </div>
        </div>
      )}
    </>
  );
};
